import { render, staticRenderFns } from "./RideCreditManagement.vue?vue&type=template&id=39632c1a&scoped=true"
import script from "./RideCreditManagement.vue?vue&type=script&lang=ts"
export * from "./RideCreditManagement.vue?vue&type=script&lang=ts"
import style0 from "./RideCreditManagement.vue?vue&type=style&index=0&id=39632c1a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39632c1a",
  null
  
)

export default component.exports